import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromActions from "./procedure-diagram.actions";
import {map, switchMap} from "rxjs/operators";
import * as fromGraphql from "./procedure-diagram.graphql";
import {Apollo} from "apollo-angular";
import {Store} from "@ngrx/store";
import {AppState} from "../../../reducers";
import {NotificationService} from "../../../../services/notification.service";
import {ResponseCodeService} from "../../../../services/response-code.service";


@Injectable()
export class ProcedureDiagramEffects {

  createProcedureDiagrams$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createProcedureDiagrams),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_PROCEDURE_DIAGRAM,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(async ({ data }: any) => {

          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertProcedureDiagram({ procedureDiagram: result?.data }));
              await this.notificationService.successMessage('Created Successfully ');
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  // deleteProcedureDiagram$ = createEffect(() => this.actions$.pipe(
  //   ofType(fromActions.removeProcedureDiagrams),
  //   switchMap((action) => {
  //     return this.apollo.mutate({
  //       mutation: fromGraphql.DELETE_FILLABLE_FORM,
  //       variables: {
  //         formUid: action?.formUid,
  //       }
  //     }).pipe(
  //       this.notificationService.catchError('Problem occurred while deleting record'),
  //       map(async ({ data }: any) => {
  //         if (data) {
  //           const result: any = Object.values(data)[0];
  //           if (result?.response?.code == '9000') {
  //             this.store.dispatch(fromActions.deleteProcedureDiagram({ id: action.id }));
  //             await this.notificationService.successMessage('Deleted Successfully');
  //           } else {
  //             await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
  //           }
  //         }
  //       })
  //     );
  //   })
  // ), { dispatch: false });

  getAllProcedureDiagrams$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getProcedureDiagrams),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_PROCEDURE_DIAGRAM,
        fetchPolicy: 'network-only',
        variables: {
          serviceUniqueId: action.serviceUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching procedure diagram'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadProcedureDiagrams({ procedureDiagrams: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });


  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
